// extracted by mini-css-extract-plugin
module.exports = {"navList":"Teacher3dNavMenu_navList__8pD2r"};